import { apiInstance } from 'api/utils';
import { FundType } from 'store/modules/Funds/types';

const fundsApi = {
  getFundsList: ({ query }: { query: string | number }) => {
    return apiInstance.request({
      method: 'GET',
      url: '/funds/provider/',
      params: {
        isin: query,
        name: query,
        citi_code: query
      }
    });
  },
  filterFunds: (payload: any = {}) => {
    return apiInstance.request({
      method: 'POST',
      url: '/funds/search/',
      params: {
        page: payload?.params?.page,
        pageSize: payload?.params?.pageSize || 25
      },
      data: { filters: payload.filters, sorting: payload.sorting }
    });
  },
  getFundOptions: () => {
    return apiInstance.request({
      method: 'GET',
      url: '/funds/options/'
    });
  },
  addNewFund: ({ fundData }: { fundData: FundType }) => {
    return apiInstance.request({
      method: 'POST',
      url: `/funds/cip/`,
      data: fundData
    });
  },
  bulkImportFunds: (data: string[]) => {
    return apiInstance.request({
      method: 'POST',
      url: '/funds/provider/',
      data: {
        codes: data
      }
    });
  },
  getFactsheet: (data: any) => {
    return apiInstance.request({
      method: 'POST',
      url: `/funds/${data.id}/factsheet/`,
      data,
      responseType: 'blob'
    });
  },
  getFactsheetPastPerformance: (id: number) =>
    apiInstance.request({
      method: 'POST',
      url: `/funds/${id}/past-performance/`
    }),
  getFactsheetAssetAllocation: (id: number) =>
    apiInstance.request({
      method: 'POST',
      url: `/funds/${id}/asset-allocation/`
    }),
  getFactsheetCountryBreakdown: (id: number) =>
    apiInstance.request({
      method: 'POST',
      url: `/funds/${id}/country-breakdown/`
    }),
  getFactsheetRegionalBreakdown: (id: number) =>
    apiInstance.request({
      method: 'POST',
      url: `/funds/${id}/regional-breakdown/`
    }),
  getFactsheetSectorBreakdown: (id: number) =>
    apiInstance.request({
      method: 'POST',
      url: `/funds/${id}/sector-breakdown/`
    })
};

export default {
  ...fundsApi
};
